import { render, staticRenderFns } from "./TaskForm.vue?vue&type=template&id=746b1138&scoped=true&"
import script from "./TaskForm.vue?vue&type=script&lang=js&"
export * from "./TaskForm.vue?vue&type=script&lang=js&"
import style0 from "./TaskForm.vue?vue&type=style&index=0&id=746b1138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746b1138",
  null
  
)

export default component.exports